/**
 * VisibilityNotice — the persistent "visible to other testers" warning shown on
 * the bug-report form BEFORE submit.
 *
 * Story: epic-uat-portal-001-10 (design D3).
 *
 * D3 accepted that a filed bug's body + screenshots are shared tester-to-tester
 * on the status board (only the reporter's contact stays team-private). This
 * notice is the agreed mitigation for the PII-in-screenshots risk: it must be on
 * the form, before the tester submits, so they can self-redact. Plan Review Focus
 * item 3 pins a test that this renders.
 */

export function VisibilityNotice() {
  return (
    <div
      role="note"
      data-testid="visibility-notice"
      className="rounded border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900"
    >
      <strong className="font-semibold">Before you submit:</strong> what you submit
      here — screenshots included — is visible to other testers. Don&apos;t include
      anything private (passwords, personal messages, payment details, or other
      people&apos;s information). Your name and contact details are never shown on
      the board.
    </div>
  );
}
